import React from 'react';
import { useLocales } from '@/locales';
import AuthLayout from '@/pages/auth/components/common/AuthLayout';
import OptimizedLoadingOverlay from '@/pages/auth/components/common/OptimizedLoadingOverlay';
import AuthErrorBoundary from '@/pages/auth/components/common/AuthErrorBoundary';
import { UnifiedAuthCard } from '@/pages/auth/components/unified';
import { useAuthFlowStore } from '@/pages/auth/stores/authFlowStore';

const AuthPage = () => {
  const { translate } = useLocales();
  const { getIsAnyLoading } = useAuthFlowStore();
  const isLoading = getIsAnyLoading();

  const handleAuthError = (error, errorInfo) => {
    // Log error for monitoring
    console.error('Authentication error:', error, errorInfo);

    // In production, you might want to send this to an error reporting service
    if (process.env.NODE_ENV === 'production') {
      // Example: Send to error reporting service
      // errorReportingService.captureException(error, { extra: errorInfo });
    }
  };

  return (
    <AuthErrorBoundary onError={handleAuthError}>
      <OptimizedLoadingOverlay
        open={isLoading}
        message={translate('Authenticating') || 'Authenticating...'}
        variant="detailed"
        persistent
      />
      <AuthLayout>
        <UnifiedAuthCard />
      </AuthLayout>
    </AuthErrorBoundary>
  );
};

export default AuthPage;
